import Flags from '../../constants/Flags.js';
import ExternalLink from '../ExternalLink/ExternalLink.js';

function MediaPreviewWebsiteLink2({
  linkUrl,
  title,
  ogDescription,
}: {
  linkUrl: string;
  title: string;
  ogDescription: string;
}) {
  return (
    <div className="flex h-full max-w-full contain-content" data-testid="MediaPreviewWebsiteLink">
      <ExternalLink
        className="text-blue100 flex max-w-full h-full w-full contain-content items-center gap-1"
        url={linkUrl}
      >
        <p className="text-sm">{title}</p>
        {Flags.OPEN_GRAPH_DESCRIPTION && ogDescription && (
          <p className="text-blue100">{ogDescription}</p>
        )}
      </ExternalLink>
    </div>
  );
}

export default MediaPreviewWebsiteLink2;
